import React, { Component, ReactNode } from 'react'
import { Form, Dropdown as SDropdown, Input as SInput, Button as SButton, FormDropdownProps, DropdownItemProps, Grid, StrictGridColumnProps } from 'semantic-ui-react'
import { FastField, Field, getIn } from 'formik'
import ErrorMessage from './ErrorMessage'
import { FormikComponentProps, getFieldError, setFieldValue } from './FormikHelpers'
import { collectFeatureOptions, getLocalizedLabel, getmeta, Meta, valueIsSimpleId, valueNotEmpty } from '../../common'
import { withTranslation, WithTranslation } from 'react-i18next'

export interface InputFeatureTypeProps extends FormikComponentProps, WithTranslation {
  inputProps?: FormDropdownProps
  options?: DropdownItemProps[]
  placeholder?: string,
  basePath?: string,
  fmeta: any,
  name: string,
  widthCols: number,
  subSpecOnly?: boolean,
  defaultNewSubspec?: string,
  requireSubspec?: boolean,
  current_version?: string|null
}

interface InputFeatureTypeState {
  base: string,
  spec: string|null,
  aggrspec: string|null,
  version: string|null
}

class InputFeatureType extends Component<InputFeatureTypeProps, InputFeatureTypeState> {

    id: string
    _dropdown: Component<FormDropdownProps, any, any>|null = null

    state = {
      base: '',
      spec: null,
      aggrspec: null,
      version: null
    }

    constructor(props) {
        super(props)
        const {id, name} = props
        this.id = id || `field_${name}`
    }

  render() {

    const {
        name,
        label,
        options,
        placeholder,
        inputProps = {},
        fieldProps = {},
        errorComponent = ErrorMessage,
        fast,
        basePath,
        i18n,
        t,
        fmeta,
        widthCols,
        subSpecOnly,
        validate,
        defaultNewSubspec,
        requireSubspec,
        current_version
    } = this.props

    const composeNewType = (base: string, specs: string[]|null, aggrspec: string|null, version: string|null=null) => {
      let type = base
      if (specs!==null && specs!==undefined) {
        type = [type, ...specs].join(':')
      }
      if (aggrspec!==null && aggrspec!==undefined) {
        type = [type, aggrspec].join(':')
      }
      if (version!==null && version!==undefined) {
        type = [type, '_'+version].join(':')
      }
      return base ? type : type.substring(1)
    }

    const haveOptions = Boolean(options)
    const myoptions = haveOptions ? options : [{key: basePath, text: basePath, value: basePath}]

    const {onChange, ...safeInputProps} = inputProps
    const DesiredField = fast === true ? FastField : Field
    const newSpecValidation = (str: string) => {
      return basePath ? valueIsSimpleId(str.substring(basePath.length).replace(/^:+/,'')) : undefined
    }

    const defaultValidate = (s: string) => {
      if (!s || String(s).includes('::') || (String(s).endsWith(':'))) return t('Incomplete specification')
    }

    return (
      <DesiredField name={name} validate={validate ? validate : haveOptions ? defaultValidate : newSpecValidation}>
        {({field, form, formmeta}) => {
          const error = getFieldError(field, form)
          let columns = 0
          //const fmeta = getmeta(meta, 'feature', field.value)
          const base = subSpecOnly ? '' : fmeta && fmeta.type
          const basePrefixLen = base ? base.length+1 : 0
          let givenSpecs = fmeta?.type && field.value !== null && field.value !== undefined && field.value.length !== base.length ?
                field.value.substring(basePrefixLen).split(':') : (requireSubspec ? [''] : [])

          const lastSpec : string = givenSpecs.length ? givenSpecs[givenSpecs.length-1] : ''
          const version = lastSpec.startsWith('_') && current_version && !fmeta?.params?.aggregate ? givenSpecs.pop().substring(1) : null

          let specs = fmeta?.params && fmeta.subspec_required ?
              fmeta.params.subspecs.map((v,i) => givenSpecs.shift() || '')
            : fmeta?.params && fmeta.params.aggregate ?
              givenSpecs.length < 2 ? null : [givenSpecs.slice(0, -1).join(':')]
            : givenSpecs.length ? [givenSpecs.join(':')] : []

          // if there were required subspecs but no additional aggregate, do not forget possible additional subspec!
          if (fmeta?.params && fmeta.subspec_required && !fmeta.params.aggregate)
            specs = givenSpecs.length ? specs.concat([givenSpecs.join(':')]) : specs

          // aggrspec required for aggregates that do not have a default specification; null => not required; '' => required
          const aggrspec = fmeta?.params?.aggregate ? (
              fmeta.params.aggregate.default_spec ? givenSpecs.pop() : givenSpecs.pop() || ''
            ) : null

          // enforce update for valiadation of incomplete specification
          //const current = composeNewType(fmeta, base, specs, aggrspec)
          //if (field.value != current) setFieldValue(form, name, current, true)
          //console.log("After",specs, aggrspec)
          //const allowSubspec = fmeta && specs.length == 0 && (aggrspec === null || typeof(aggrspec) === 'undefined')

          let subspecComps: ReactNode[] = (specs !== undefined && specs !== null) ?
            specs.map((spec, i) => {
              const sparams = fmeta.params?.subspecs?.length > i ? fmeta.params.subspecs[i] : null
              if (sparams?.type === 'enum') {
                const soptions = sparams.enum.map(o => ({key: o.value, value: o.value, text: getLocalizedLabel(o.label, i18n.language)}))
                columns += 3
                return(
                <Grid.Column width={3}>
                <Form.Field error={!!error} {...fieldProps}>
                <SDropdown
                    id={this.id+'_s'+i.toString()}
                    name={name}
                    options={soptions}
                    selectOnBlur={false}
                    selectOnNavigation={false}
                    selection
                    search
                    {...safeInputProps}
                    disabled={safeInputProps.disabled}
                    value={spec}
                    placeholder={sparams ? getLocalizedLabel(sparams.label, i18n.language) : t('specification')}
                    //className={(curValue() !== formmeta.initialValue) && ( curValue() !== '' && !formmeta.initalValue) ? 'changed' : ''}
                    onChange={(e, {name, value}) => {
                      const newSubValue = String(value).trim()
                      const newValue = composeNewType(base, specs.map((s,ii) => ii===i ? newSubValue : s), aggrspec)
                      setFieldValue(form, name, newValue, true)
                      Promise.resolve().then(() => {
                        onChange && onChange(e, {name, newValue})
                      })
                    }}
                    onBlur={form.handleBlur}
                  />
                  { i===0 && error && subSpecOnly && (
                    React.createElement(errorComponent, { message: getIn(form.errors, name) })
                  )}
                  </Form.Field>
                </Grid.Column>
                )
              } else {
                columns += 2
                return (
                <Grid.Column width={2}>
                <Form.Field error={!!error} {...fieldProps}>
                <SInput
                    id={this.id+'_s'+i.toString()}
                    name={name}
                    {...safeInputProps}
                    disabled={safeInputProps.disabled}
                    value={spec}
                    placeholder={sparams ? getLocalizedLabel(sparams.label, i18n.language) : t('specification')}
                    //className={(curValue() !== formmeta.initialValue) && ( curValue() !== '' && !formmeta.initalValue) ? 'changed' : ''}
                    onChange={(e, {name, value}) => {
                      const newSubValue = String(value).trim()
                      const newValue = composeNewType(base, specs.map((s,ii) => ii===i ? newSubValue : s), aggrspec)
                      setFieldValue(form, name, newValue, true)
                      Promise.resolve().then(() => {
                        onChange && onChange(e, {name, newValue})
                      })
                    }}
                    onBlur={form.handleBlur}
                  />
                  { i===0 && error && subSpecOnly && (
                    React.createElement(errorComponent, { message: getIn(form.errors, name) })
                  )}
                  </Form.Field>
                </Grid.Column>
                )
              }
              }
            )
          : []

          // allow additional subspecification?
          if (!safeInputProps.disabled && !fmeta?.params?.aggregate && !(specs.length > (fmeta.params?.subspecs?.length || 0)))  {
            columns += 2
            subspecComps.push(
                <Grid.Column width={2}>
                <SButton type="button" size="mini" icon="ellipsis horizontal" title={t('Add specification')}
                    onClick={(e,d) => {setFieldValue(form, name, composeNewType(base, [...(specs || []), defaultNewSubspec||''], aggrspec), true);e.preventDefault()}}/>
                </Grid.Column>
            )
          }
      
          let aggrspecComp: ReactNode = null
          if (aggrspec !== null && aggrspec !== undefined) {
              const aggrlabel = getLocalizedLabel(fmeta.params.aggregate.label, i18n.language)
              aggrspecComp = (
                  <Grid.Column width={2}>
                  <Form.Field error={aggrspec===''} {...fieldProps}>
                  <SInput
                      id={this.id+'_a'}
                      name={name}
                      {...safeInputProps}
                      disabled={safeInputProps.disabled}
                      value={aggrspec}
                      placeholder={aggrlabel}
                      //className={(curValue() !== formmeta.initialValue) && ( curValue() !== '' && !formmeta.initalValue) ? 'changed' : ''}
                      onChange={(e, {name, value}) => {
                        const newSubValue = String(value).trim()
                        const newValue = composeNewType(base, specs, newSubValue)
                        setFieldValue(form, name, newValue, true)
                        Promise.resolve().then(() => {
                          onChange && onChange(e, {name, newValue})
                        })
                      }}
                      onBlur={form.handleBlur}
                    />
                    </Form.Field>
                  </Grid.Column>
              )
            columns += 2
          }  else if (fmeta?.params && fmeta.params.aggregate) {
            const aggrlabel = getLocalizedLabel(fmeta.params.aggregate.label, i18n.language)
            aggrspecComp = (
              <Grid.Column width={2}>
                {
                (!safeInputProps.disabled && (!specs.length || specs[specs.length-1]!=='')) ?
                  <SButton type="button" size="mini" icon="ellipsis horizontal" title={t('Add specification')+" '"+aggrlabel+"'"}
                      onClick={(e,d) => {setFieldValue(form, name, composeNewType(base, specs, ''), true);e.preventDefault()}}/> 
                : null 
                }
              </Grid.Column>)
            columns += 2
          }

          let versionComp: ReactNode = null
          if (current_version) {
            columns += 1
            versionComp = (
              <Grid.Column width={1}>
                {version ? <span className='feature_version'>(v{version})</span> : null}
              </Grid.Column>
            )
          }
          
          const width = widthCols - columns

          return (
            <>
              { width ? 
                <Grid.Column width={width as StrictGridColumnProps['width']}>
                  { !subSpecOnly ?
                  <Form.Field error={false} {...fieldProps}>
                    <SDropdown
                      ref={el => (this._dropdown = el)}
                      id={this.id+'_b'}
                      name={name}
                      options={myoptions}
                      placeholder={placeholder}
                      selectOnBlur={false}
                      selectOnNavigation={false}
                      selection
                      search
                      {...safeInputProps}
                      disabled={!haveOptions || safeInputProps.disabled}
                      value={base}
                      //className={haveOptions && curValue() !== formmeta.initialValue ? 'changed' : ''}
                      onChange={(e, {name, value}) => {
                        const newValue = composeNewType(String(value).trim(), null, null)
                        setFieldValue(form, name, newValue, false)
                        Promise.resolve().then(() => {
                          onChange && onChange(e, {name, newValue})
                        })
                      }}
                    />
                    {error && (
                      React.createElement(errorComponent, { message: getIn(form.errors, name) })
                    )}
                  </Form.Field>
                  : null }
                </Grid.Column> 
              : null }
              {subspecComps}
              {aggrspecComp}
              {versionComp}
              </>
          )
        }}
      </DesiredField>
    )
  }
}

export default  withTranslation()(InputFeatureType)